export default "__VITE_ASSET__BzRp8CJF__";